/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Format_MenuInputs */

const en_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format menu`)
};

const fr_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu format`)
};

const de_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatmenü`)
};

const it_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu Formato`)
};

const ru_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню форматирования`)
};

const es_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de formato`)
};

const zh_cn2_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式菜单`)
};

const ja_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーマットメニュー`)
};

const hi_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारूप मेनू`)
};

const pt_pt2_format_menu = /** @type {(inputs: Format_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar menu`)
};

/**
* | output |
* | --- |
* | "Format menu" |
*
* @param {Format_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const format_menu = /** @type {((inputs?: Format_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Format_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_format_menu(inputs)
	if (locale === "de") return de_format_menu(inputs)
	if (locale === "it") return it_format_menu(inputs)
	if (locale === "ru") return ru_format_menu(inputs)
	if (locale === "es") return es_format_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_format_menu(inputs)
	if (locale === "ja") return ja_format_menu(inputs)
	if (locale === "hi") return hi_format_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_format_menu(inputs)
	return en_format_menu(inputs)
});